import { Component, OnDestroy, OnInit } from '@angular/core';
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';
import { MenuController } from '@ionic/angular';
import { ToasterService } from '../../../../../app/common/services/toaster.service';
import { NavController } from '@ionic/angular';
@Component({
  selector: 'app-scan-barcode',
  templateUrl: './scan-barcode.page.html',
  styleUrls: [
    './scan-barcode.page.scss'
  ]
})
export class ScanComponent implements OnInit, OnDestroy {

  html5QrCode!: Html5Qrcode;
  garmentCode: string = "";
  loaded: boolean = false;
  stopName: string = "";
  breadcrumbs = [];
  messageCode: string = "";
  selectedReasons: string[] = [];
  selectedmessageCode: string[] = [];
  routeStopName: string = "";
  messageText: string = '';
  garment: any;
  isScanning: boolean = false;

  lastScannedCode: string = '';
  sameScanCount: number = 0;
  requiredMatches: number = 3;
  scanLock: boolean = false;

  constructor(
    public menu: MenuController,
    private toasterService: ToasterService,
    private navController: NavController
  ) {

  }
  ngOnInit(): void {
    this.loaded = true;
  }


  ionViewWillLeave() {
    this.menu.enable(false);
  }

  ionViewWillEnter() {
    this.menu.enable(false);
    this.isScanning = false;
    this.garmentCode = '';
  }

  // stopScan() {
  //   this.isScanning = false;

  //   if (this.html5QrCode) {
  //     this.html5QrCode.stop()
  //       .then(() => {
  //         this.html5QrCode.clear();
  //         this.html5QrCode = null as any; 
  //       })
  //       .catch(() => {});
  //   }
  // }
  async stopScan() {

    this.isScanning = false;

    if (this.html5QrCode) {

      try {

        await this.html5QrCode.stop();

        await this.html5QrCode.clear();

        this.html5QrCode = null as any;

      } catch (error) {

        console.log(error);
      }
    }
  }
  startScan() {
    this.isScanning = true;
    this.lastScannedCode = '';
    this.sameScanCount = 0;
    this.scanLock = false;
    const allSupportedFormats = [
      // Html5QrcodeSupportedFormats.QR_CODE,
      // Html5QrcodeSupportedFormats.AZTEC,
      // Html5QrcodeSupportedFormats.CODABAR,
      // Html5QrcodeSupportedFormats.CODE_39,
      // Html5QrcodeSupportedFormats.CODE_93,
      // Html5QrcodeSupportedFormats.CODE_128,
      // Html5QrcodeSupportedFormats.DATA_MATRIX,
      // Html5QrcodeSupportedFormats.MAXICODE,
      // Html5QrcodeSupportedFormats.ITF,
      // Html5QrcodeSupportedFormats.EAN_13,
      // Html5QrcodeSupportedFormats.EAN_8,
      // Html5QrcodeSupportedFormats.PDF_417,
      // Html5QrcodeSupportedFormats.RSS_14,
      // Html5QrcodeSupportedFormats.RSS_EXPANDED,
      // Html5QrcodeSupportedFormats.UPC_A,
      // Html5QrcodeSupportedFormats.UPC_E,
      // Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION
      Html5QrcodeSupportedFormats.QR_CODE,
      Html5QrcodeSupportedFormats.CODE_128,
      // Html5QrcodeSupportedFormats.CODE_39,
      // Html5QrcodeSupportedFormats.EAN_13
    ];

    // const scannerConfig: any = {
    //   formatsToSupport: allSupportedFormats, // All 1D/2D
    //   // experimentalFeatures: {
    //   //   useBarCodeDetectorIfSupported: true
    //   // },
    //   //fps: 20, // Inherited operational properties
    //   fps: 8, // Inherited operational properties
    //   qrbox: { width: 320, height: 120 },
    //   disableFlip: true,
    // };
    const scannerConfig: any = {

      formatsToSupport: [
        Html5QrcodeSupportedFormats.QR_CODE,
        Html5QrcodeSupportedFormats.CODE_128
      ],

      fps: 15,

      // qrbox: {
      //   width: 280,
      //   height: 200
      // },
      qrbox: (viewfinderWidth: number) => ({
        width: Math.min(viewfinderWidth * 0.85, 340),
        height: 220
      }),
      // qrbox: (viewfinderWidth: number, viewfinderHeight: number) => ({
      //   width: Math.min(viewfinderWidth * 0.85, 340),
      //   height: Math.min(viewfinderHeight * 0.5, 200)
      // }),
      // aspectRatio: 1.777778,

      disableFlip: true,

      experimentalFeatures: {
        useBarCodeDetectorIfSupported: true
      },

      videoConstraints: {
        facingMode: "environment",
        // width: { ideal: 1920 },
        // height: { ideal: 1080 },
        // focusMode: "continuous",
        // advanced: [{ zoom: 2 }]
      }
    };
    setTimeout(() => {
      this.html5QrCode = new Html5Qrcode('reader');
      this.html5QrCode.start(
        { facingMode: 'environment' },
        scannerConfig,
        // (decodedText) => {
        //   this.garmentCode = decodedText;
        //   this.stopScan();
        //   this.getGarmentDetail();
        // }
        async (decodedText) => {
          if (this.scanLock) {
            return;
          }
          if (!/^[0-9]{8}$/.test(decodedText)) {
            return;
          }
          console.log('Detected:', decodedText);

          // Same value again
          if (decodedText === this.lastScannedCode) {

            this.sameScanCount++;

          } else {

            // New value
            this.lastScannedCode = decodedText;
            this.sameScanCount = 1;
          }

          console.log('Stable Count:', this.sameScanCount);

          // Accept only after stable reads
          if (this.sameScanCount >= this.requiredMatches) {

            this.scanLock = true;

            this.garmentCode = decodedText;

            await this.stopScan();

            this.getGarmentDetail();
          }
        },
        (error) => {
        }
      );
    }, 300);
  }

  ngOnDestroy(): void {
    this.stopScan();
  }
  getGarmentDetail() {
    this.loaded = false;
    this.garmentCode = this.garmentCode?.trim();
    if (!this.garmentCode) {
      this.toasterService.presentToast('danger', '', 'Please Enter Garment Code ', 2000);
      this.loaded = true;
      return;
    }
    // const numericRegex = /^[0-9]{1,8}$/;
    const numericRegex = /^[0-9]{8}$/;
    if (!numericRegex.test(this.garmentCode)) {
      this.toasterService.presentToast('danger', '', 'Invalid Garment Code.It should be 8 digits.', 2000);
      this.loaded = true;
      return;
    }

    if (this.garmentCode != null && this.garmentCode.length > 0) {
      this.navController.navigateForward([`/auth/login/scan-barcode/detail/${this.garmentCode}`]);
    }

    this.loaded = true;

  }
}
